import { makeHasExperienceLogicByFinancialProduct, } from '../../logic/hasExperience/make';
import { STypeGrp } from '../../../../types';
export * from '../../../financialProducts/fields/SUBORDINATED_BOND/logic';
export function makeHasExperienceLogic(props) {
    var alternatives = props.alternatives;
    return makeHasExperienceLogicByFinancialProduct({
        financialProduct: STypeGrp.OBLIGATIONS_SUB,
        alternatives: alternatives,
    });
}
